import React from 'react';
import Sidebar from './components/Sidebar';
import Navigation from './components/Navigation';
// import { NavLink } from 'react-router-dom';
// import { FaEyeSlash, FaDownload } from 'react-icons/fa';
// import { FaDownload,FaEyeSlash, FaArrowAltCircleUp,FaPlusCircle} from 'react-icons/fa';

// import { IoIosAddCircle } from "react-icons/io";

const Setting = () => {
    // const [phone, setPhone] = useState('');
    // const [email, setEmail] = useState('');
    // const [showOtp, setShowOtp] = useState(false);

    // const handleSubmit = () => {
    //     setShowOtp(true);
    // };

    // const handleOtpSubmit = () => {
    // };
    return (
        <>
            <div className='overviewsaa'>
                <h4>Setting</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Setting;
